import PlacesAutocomplete from "stimulus-places-autocomplete";

export default class extends PlacesAutocomplete {
  connect() {
    this.element.setAttribute("data-action", "google-maps-callback@window->address-autocomplete#initAutocomplete");

    super.connect();
  }

  addressTargetConnected() {
    this.addressTarget.setAttribute("data-action", "keydown->address-autocomplete#preventSubmit");
  }

  countryTargetConnected() {
    this.countryTarget.addEventListener("country-state-change", (event) => this.handleFullUpdate(event));
    this.countryTarget.addEventListener("change", () => this.refreshStates());
  }

  formatAddressComponents(addressComponents) {
    const data = {};
    addressComponents.forEach((component) => {
      const type =
        [
          "country",
          "administrative_area_level_1",
          "administrative_area_level_2",
          "administrative_area_level_3",
          "state",
          "locality",
          "route",
          "street_number",
          "postal_code",
        ].find((findType) => component.types.includes(findType)) || component.types[0];

      // Use short name for country to get "US" instead of United States
      data[type] = type === "country" ? component.short_name : component.long_name;
    });

    return data;
  }

  setAddressComponents(address) {
    super.setAddressComponents(address);

    // Set value of address to just street number and street
    this.addressTarget.value = `${address.street_number || ""} ${address.route}`.trim();

    const countryState = {
      state: address.administrative_area_level_1 || "",
      country: address.country || "",
    };

    this.handleFullUpdate({ detail: countryState });
  }

  handleFullUpdate({ detail }) {
    if (this.hasCountryTarget) {
      this.countryTarget.value = detail.country;
      this.refreshStates(detail.country, detail.state);
    }
  }

  refreshStates(country = null, stateVal = null) {
    this.loadStates(country).then((data) => {
      this.stateTarget.options.length = 0;

      this.stateTarget.appendChild(new Option("", ""));
      data.customers.map((state) => this.stateTarget.appendChild(new Option(state.name, state.code)));

      if (stateVal) {
        this.stateTarget.value = stateVal;
      }
    });
  }

  loadStates(country) {
    return fetch(this.getUrl(country), { headers: { Accept: "application/json" } }).then((response) => response.json());
  }

  getUrl(country) {
    return `${window.get_states_for_country_customers_path}?country_name=${country || this.countryTarget.value}`;
  }

  get autocompleteOptions() {
    return {
      fields: ["address_components"],
      componentRestrictions: {
        country: this.countryValue,
      },
    };
  }
}
